// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  bridgeId: __t.u64().primaryKey().name("bridge_id"),
  assetId: __t.u64().name("asset_id"),
  resultAssetId: __t.u64().name("result_asset_id"),
  direction: __t.string(),
  fidelityTier: __t.u8().name("fidelity_tier"),
  actor: __t.identity(),
  at: __t.timestamp(),
});
